<script lang="ts">
  import { AppState } from '../../etc/stores';
  import flagKeys from '../../etc/flagKeys';

  const { primary200 } = $AppState.theme.colors;
</script>

<svg
  width="32"
  height="33"
  viewBox="0 0 32 33"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  {#if $AppState.featureFlags.includes(flagKeys.NEW_COIN_ICON)}
    <path
      d="M5.44543 9.31015V16.3938C5.44543 19.3281 10.1704 21.7065 16 21.7065C21.8296 21.7065 26.5546 19.3281 26.5546 16.3938V9.31015"
      stroke="#7A89B0"
      stroke-width="1.5"
    />
    <path
      d="M5.44543 16.3938V23.4774C5.44543 26.4118 10.1704 28.7901 16 28.7901C17.2074 28.7901 18.3674 28.6881 19.4479 28.5002M26.5546 16.3938V21.2914"
      stroke="#7A89B0"
      stroke-width="1.5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 14.6254C21.8291 14.6254 26.5546 12.2468 26.5546 9.3127C26.5546 6.37858 21.8291 4 16 4C10.1709 4 5.44543 6.37858 5.44543 9.3127C5.44543 12.2468 10.1709 14.6254 16 14.6254Z"
      stroke="#7A89B0"
      stroke-width="1.5"
      stroke-linecap="square"
    />
    <path
      d="M21 26.6748H29M29 26.6748L25 22.6748M29 26.6748L25 30.6748"
      stroke={primary200}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  {:else}
    <path
      d="M16.0004 7.72217L18.2003 13.3001L23.7782 15.4999L18.2003 17.6998L16.0004 23.2777L13.8005 17.6998L8.22266 15.4999L13.8005 13.3001L16.0004 7.72217Z"
      fill="#7A89B0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.1637 27.9989C16.1092 27.9996 16.0547 28 16 28C9.09644 28 3.5 22.4036 3.5 15.5C3.5 8.59644 9.09644 3 16 3C22.9036 3 28.5 8.59644 28.5 15.5C28.5 17.947 27.7969 20.2298 26.5816 22.1573L27.6663 23.242C29.1408 21.0246 30 18.3626 30 15.5C30 7.76801 23.732 1.5 16 1.5C8.26801 1.5 2 7.76801 2 15.5C2 23.232 8.26801 29.5 16 29.5C16.5469 29.5 17.0865 29.4686 17.617 29.4076C16.9849 29.1205 16.4699 28.6204 16.1637 27.9989Z"
      fill="#7A89B0"
    />
    <path
      d="M18.8564 25.6748C18.3042 25.6748 17.8564 26.1225 17.8564 26.6748C17.8564 27.2271 18.3042 27.6748 18.8564 27.6748V25.6748ZM26.8564 26.6748L27.5636 27.3819C27.9541 26.9914 27.9541 26.3582 27.5636 25.9677L26.8564 26.6748ZM23.5636 21.9677C23.173 21.5772 22.5399 21.5772 22.1493 21.9677C21.7588 22.3582 21.7588 22.9914 22.1493 23.3819L23.5636 21.9677ZM22.1493 29.9677C21.7588 30.3582 21.7588 30.9914 22.1493 31.3819C22.5399 31.7724 23.173 31.7724 23.5636 31.3819L22.1493 29.9677ZM18.8564 27.6748H26.8564V25.6748H18.8564V27.6748ZM22.1493 23.3819L26.1493 27.3819L27.5636 25.9677L23.5636 21.9677L22.1493 23.3819ZM26.1493 25.9677L22.1493 29.9677L23.5636 31.3819L27.5636 27.3819L26.1493 25.9677Z"
      fill={primary200}
    />
  {/if}
</svg>
